<template>
  <div ref="main" class="artist_intro-container">
    <div class="artist-info-part artist_mini-basic" style="padding:0.83vw 1.66vw;">
      <div class="artist_mini-basic_left">
        <img class="cover_url-mini" :src="info.cover_url" alt="" />
        <span class="nickname-mini">{{ info.nickname }}</span>
      </div>
      <div class="artist_mini-basic_right">
        <a v-for="(tab,tab_i) in tabs" :key="tab.value" :class="{active:tab_active===`tab${tab_i+1}`}"
           @click="toScroll(`tab${tab_i+1}`,tab.permission)">{{ tab.label }}</a>
      </div>
    </div>
    <ArtistInfo :artist-id="artist_id" />
    <div v-for="(item,index) in tabs" :key="item.value">
      <component v-if="userPermissions.indexOf(item.permission) !== -1" :ref="`tab${index+1}`" v-bind:is="item.value"
                 :artist-id="artist_id" class="artist-info-part"></component>
    </div>

    <!-- 返回顶部按钮 -->
    <div v-show="showBackToTop" class="back-to-top" @click="scrollToTop">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 19V5M12 5L5 12M12 5L19 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ArtistInfo from './ArtistInfo'
import TrendData from './TrendData'
import RevenueData from './RevenueData'
import CommissionData from './CommissionData.vue'
import BsData from './BsData'
import TiktokData from './TiktokData'
import Quotation from './Quotation'
import ArtistLog from '@/pages/artist/ArtistLog'

const tabs = [
  { value: 'RevenueData', label: '营收数据', permission: 'artist_revenue_data' },
  { value: 'CommissionData', label: '佣金收入', permission: 'artist_revenue_data' },
  { value: 'BsData', label: '电商数据', permission: 'artist_bs_data' },
  { value: 'TiktokData', label: '抖音挂车', permission: 'artist_case_record' },
  { value: 'Quotation', label: '刊例报价', permission: 'artist_intro_plc' },
  { value: 'TrendData', label: '涨粉数据', permission: 'artist_trend_data' },
  { value: 'ArtistLog', label: '操作日志', permission: 'artist_log' }
]
export default {
  name: 'ArtistIntroArtistIntro',
  computed: {
    ...mapGetters(['userPermissions'])
  },
  components: {
    ArtistInfo, TrendData, RevenueData, BsData, TiktokData, Quotation, CommissionData, ArtistLog
  },
  data() {
    return {
      tabs,
      tab_active: 'tab1',
      artist_id: null,
      info: {},
      showBackToTop: false
    }
  },
  methods: {
    toScroll: function(dom, permission) {
      if (permission && this.userPermissions.indexOf(permission) === -1) {
        return this.$message.warning('暂无权限查看')
      }
      this.tab_active = dom
      const offsetTop = this.$refs[dom] ? this.$refs[dom][0].$el.offsetTop - 80 : false
      if (offsetTop) {
        // 平滑滚动到目标位置
        this.smoothScrollTo(offsetTop)
      }
    },
    // 平滑滚动函数
    smoothScrollTo(targetPosition) {
      const startPosition = window.pageYOffset || document.documentElement.scrollTop
      const distance = targetPosition - startPosition
      const duration = 500 // 滚动持续时间（毫秒）
      let startTime = null

      function animation(currentTime) {
        if (startTime === null) startTime = currentTime
        const timeElapsed = currentTime - startTime
        const progress = Math.min(timeElapsed / duration, 1)

        // 使用缓动函数使滚动更自然
        const easeInOutCubic = t => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
        const run = easeInOutCubic(progress)

        window.scrollTo(0, startPosition + distance * run)

        if (timeElapsed < duration) {
          requestAnimationFrame(animation)
        }
      }

      requestAnimationFrame(animation)
    },
    // 返回顶部
    scrollToTop() {
      this.smoothScrollTo(0)
    },
    async getInfo() {
      const { info } = await this.$api.getArtistInfo(this.artist_id)
      this.info = info
    },
    eventScroll() {
      const map = {
        tab1: undefined
      }
      const top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0

      // 控制返回顶部按钮的显示/隐藏
      this.showBackToTop = top > 300

      for (let i = 1; i <= this.tabs.length; i++) {
        map[`tab${i}`] = this.$refs[`tab${i}`] && this.$refs[`tab${i}`][0] ? this.$refs[`tab${i}`][0].$el.offsetTop : 0
      }

      if (top <= map.tab1) {
        this.tab_active = 'tab1'
      } else if (top > map.tab1 && map.tab2 >= top) {
        this.tab_active = 'tab2'
      } else if (top > map.tab2 && map.tab3 >= top) {
        this.tab_active = 'tab3'
      } else if (top > map.tab3 && map.tab4 >= top) {
        this.tab_active = 'tab4'
      } else if (top > map.tab4 && map.tab5 >= top) {
        this.tab_active = 'tab5'
      }  else if (top > map.tab5 && map.tab6 >= top) {
        this.tab_active = 'tab6'
      } else if (top > map.tab6) {
        this.tab_active = 'tab7'
      }
    }
  },
  created() {
    this.artist_id = this.$route.params.artist_id
    this.getInfo()
  },
  mounted() {
    const _t = this
    window.addEventListener('scroll', function(e) {
      _t.eventScroll(e)
    })
  }
}
</script>

<style lang="scss">
.artist_intro_main {
  height: 100vh;
}

.artist_intro-container {
  padding: 2vw 1.66vw;
  position: relative;

  .artist-info-part {
    padding: 1.66vw;
    border-radius: 12px;
    margin-bottom: 20px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), #FFFFFF;
    box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.1), 0px 4px 6px -1px rgba(0, 0, 0, 0.1);
    &__title {
      font-size: 1.04vw;
      font-weight: bold;
      line-height: 1.47vw;
      letter-spacing: normal;
      color: #000000;
      margin-bottom: 1.25vw;
    }
  }


  // 返回顶部按钮样式
  .back-to-top {
    position: fixed;
    bottom: 40px;
    right: 40px;
    width: 50px;
    height: 50px;
    background: #409EFF;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
    transition: all 0.3s ease;
    z-index: 1000;

    &:hover {
      background: #66b1ff;
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(64, 158, 255, 0.5);
    }

    &:active {
      transform: translateY(0);
    }

    svg {
      transition: transform 0.3s ease;
    }

    &:hover svg {
      transform: translateY(-2px);
    }
  }
}
</style>
